import {
  FETCH_CARE_HEARTH_INSIGHT,
  FETCH_CARE_HEARTH_INSIGHT_FAILURE,
  FETCH_CARE_HEARTH_INSIGHT_SUCCESS,
  FETCH_CARE_HEARTH_INSIGHTS,
  FETCH_CARE_HEARTH_INSIGHTS_FAILURE,
  FETCH_CARE_HEARTH_INSIGHTS_SUCCESS,
} from "./constants";

const initialState = {
  isLoadingList: false,
  listError: null,
  items: [],
  pagination: { last_page: 1, total: 0 },
  totals: null,
  note: null,
  // Verification and auto-buy figures for the chosen dates; null until the
  // API's held 12 October migration has run.
  review: null,
  isLoadingDetail: false,
  detailError: null,
  detail: null,
};

const CareHearthInsightsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CARE_HEARTH_INSIGHTS:
      return { ...state, isLoadingList: true, listError: null };
    case FETCH_CARE_HEARTH_INSIGHTS_SUCCESS:
      return {
        ...state,
        isLoadingList: false,
        items: action.payload.items,
        pagination: action.payload.pagination,
        totals: action.payload.totals,
        note: action.payload.note,
        review: action.payload.review,
      };
    case FETCH_CARE_HEARTH_INSIGHTS_FAILURE:
      return { ...state, isLoadingList: false, listError: action.payload };
    case FETCH_CARE_HEARTH_INSIGHT:
      return {
        ...state,
        isLoadingDetail: true,
        detailError: null,
        detail: null,
      };
    case FETCH_CARE_HEARTH_INSIGHT_SUCCESS:
      return { ...state, isLoadingDetail: false, detail: action.payload };
    case FETCH_CARE_HEARTH_INSIGHT_FAILURE:
      return { ...state, isLoadingDetail: false, detailError: action.payload };
    default:
      return state;
  }
};

export default CareHearthInsightsReducer;
